import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import kk from './locales/kk.json';
import legalEn from './locales/legal/en.json';
import legalKk from './locales/legal/kk.json';
import legalRu from './locales/legal/ru.json';
import ru from './locales/ru.json';
import { Languages, SUPPORTED_LANGUAGES } from './shared/constants';

// Объёмные юридические тексты (политика/согласие) держим отдельными файлами и мёржим
// под ключ `legal`, чтобы не раздувать основные локали. Доступ — t('legal.privacy...').
const resources = {
  [Languages.ru]: { translation: { ...ru, legal: legalRu } },
  [Languages.en]: { translation: { ...en, legal: legalEn } },
  [Languages.kk]: { translation: { ...kk, legal: legalKk } }
};

const fallbackLanguage = localStorage.getItem('i18nextLng') || Languages.ru;

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: fallbackLanguage,
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: {
      // Порядок определения языка
      order: ['path', 'localStorage', 'navigator', 'subdomain'],
      // Извлечение языка из первого сегмента пути (/:lang)
      lookupFromPathIndex: 0
    },
    interpolation: {
      escapeValue: false // React самостоятельно экранирует значения
    }
  });

export default i18next;
